import { type INavLinks } from 'shared/settings/routes';
import { setHash } from 'shared/utils/setHash';

export function updateActiveSection(sections: INavLinks[]): void {
  if (sections.length < 1) {
    return;
  }

  const scrollY = window.pageYOffset;

  sections.forEach(section => {
    const sectionTop = section.offsetTop - 100;

    if (section.value && scrollY > sectionTop && scrollY <= sectionTop + section.offsetHeight) {
      setHash(section.value);
    }
  });
}
